import styled from "styled-components/macro";
import { Box, BoxContent } from "../Box";
import Stack from "../Stack";
import { LockClose } from "../Icons";
import { THEME_COLOR } from "../../vars";
import usePlan from "../../hooks/use-plan";
import Title from "../Title";

export default function DemoEnded() {
  const plan = usePlan();

  return (
    <Box>
      <BoxContent dark>
        <Container>
          <Stack>
            <>
              <LockClose
                style={{ color: THEME_COLOR, width: "32px", height: "32px" }}
              />
            </>
            <Title>Your demo has ended.</Title>
            {plan.isAccountOwner
              ? "Contact Sales"
              : "Please contact your account admin."}
          </Stack>
        </Container>
      </BoxContent>
    </Box>
  );
}

const Container = styled.div`
  text-align: center;
  margin: auto;
  max-width: 1200px;
  align-items: center;
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-top: 100px;
`;
